import { render, staticRenderFns } from "./goods5.vue?vue&type=template&id=33fb421c&scoped=true"
import script from "./goods5.vue?vue&type=script&lang=js"
export * from "./goods5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb421c",
  null
  
)

export default component.exports